import { render, staticRenderFns } from "./CommentReactionDetails.vue?vue&type=template&id=7a42ebfe&scoped=true"
import script from "./CommentReactionDetails.vue?vue&type=script&lang=js"
export * from "./CommentReactionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a42ebfe",
  null
  
)

export default component.exports